import { PdfBuroLetter } from "components/PdfViewer/PdfViewerMain";
import React, { useState, useEffect } from "react";
import { getDetailSegment } from "../../../utils/buro";
import { Button } from "./wrapper";
import { pdf, Document } from "@react-pdf/renderer";
import PDFMerger from "pdf-merger-js/browser";
import { format } from "date-fns/esm";
import { API, Auth, Storage } from "aws-amplify";
import { PdfBuro } from "../../Loan/LoanMain";
import PdfDetail from "../../../Document/รหัสและสถานะบัญชี.pdf";

export const getCountLetter = async (loan) => {
  const count = await API.put("MoneyHubAdmin", `/letterCount`, {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
    body: {
      addCount: loan.length,
    },
  });
  const countLatest = Number(count) - loan.length;
  return countLatest;
};

function LetterBuro({ loan = [], buroDate, disabledLetter = false }) {
  const [loading, setLoading] = useState(false);

  const onClickLetterBuro = async () => {
    try {
      setLoading(true);
      const filename = `EXPORT_LETTER_BURO_${format(
        new Date(buroDate),
        "dd-MM-yyyy"
      )}`;
      const merger = new PDFMerger();

      let blobDetail = await Storage.get(`รหัสและสถานะบัญชี.pdf`, {
        download: true,
      });

      let fileDetail = new File([blobDetail.Body], `รหัสและสถานะบัญชี.pdf`, {
        type: "pdf",
      });
      
      let index = 0;
      for (const itemLoan of loan) {
        const dataBuro = getDetailSegment({
          currentDate: new Date(buroDate),
          dataExport: [itemLoan],
          showLog: true,
          logType: "KEY",
          addressComma: true,
        });

        const letter_id = await getCountLetter(loan);

        let blobBuro = await pdf(
          <Document>
            <PdfBuro data={itemLoan} letter_id={letter_id} index={index} />
          </Document>
        ).toBlob();

        let blob = await pdf(
          <PdfBuroLetter dataPdf={dataBuro} oriLoan={itemLoan} />
        ).toBlob();

        await merger.add(blobBuro);
        await merger.add(blob);
        await merger.add(fileDetail);
        index++;
      }
      await merger.save(filename);
    } catch (error) {
      console.log("letter buro error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <Button
        onClick={onClickLetterBuro}
        disabled={loan.length === 0 || loading || disabledLetter}
        loading={loading}
        color="blue"
      >
        Letter Buro
      </Button>
    </div>
  );
}

export default LetterBuro;
